import { render } from "./CompanyNameCell.vue?vue&type=template&id=23af7000"
import script from "./CompanyNameCell.vue?vue&type=script&lang=js"
export * from "./CompanyNameCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__